export default "/048cb1f2b29308e18768c65cfd51e426596a830c/a70fe28c30edbe909cade8425716fdee.svg";